import React from "react";
import MulSelector from "../TeaSelector/MultipleSelector";
import { useIntl } from 'umi';

export default function FrequencyAll(props: any) {
  const {
    onConfirm,
    value = [],
  } = props;

  const { formatMessage } = useIntl();

  const gameType = [
    {
      value: 'Hour',
      text: formatMessage({ id: 'dbi-sm-filter-hour' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-hour' }),
    },
    {
      value: 'Day',
      text: formatMessage({ id: 'dbi_day' }),
      buttonText: formatMessage({ id: 'dbi_day' }),
    },
    {
      value: 'Week',
      text: formatMessage({ id: 'dbi_week' }),
      buttonText: formatMessage({ id: 'dbi_week' }),
    },
    {
      value: 'Month',
      text: formatMessage({ id: 'dbi_month' }),
      buttonText: formatMessage({ id: 'dbi_month' }),
    },
    {
      value: 'Quarter',
      text: formatMessage({ id: 'dbi-sm-filter-quarter' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-quarter' }),
    },
  ]

  const handleChange = (values: string[] | string) => {
    if (onConfirm instanceof Function) {
      onConfirm(values);
    }
  };

  return (
    <MulSelector
      num={3}
      value={typeof value === 'string' ? [] : value}
      options={gameType}
      buttonName={formatMessage({ id: 'dbi-sm-filter-frequency' })}
      onChange={handleChange}
    />
  )
}
